export default (state = false, action) => {
    switch (action.type) {
        case 'INSTANCE_CONFIGURED':
            return action.instance;
        case 'INSTANCE_MAINTENANCE_REDIRECT':
            return action.instance;
        case 'INSTANCE_ERROR':
            if (state && state.maintenanceRedirectUrl) {
                return state;
            }
            return action.instance;
        default:
            return state
    }
}
